<template>
  <nav
    data-test="navigation-list"
    class="navigation"
  >
    <ul class="navigation__links">
      <li
        v-for="(link, i) in navLinks"
        :key="i"
        class="navigation__link"
      >
        <NuxtLink
          :data-test="`${(link.to as To)?.name || link.to}`"
          :to="link.to"
          :class="{ 'route-exact-match': isMatch(link.to) }"
        >
          {{ link.text }}
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { RouteLocationRaw, useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

interface To {
  name: string
}

interface NavLink {
  text: string
  to: To | string
}

interface Props {
  navLinks: NavLink[]
  matchOnPathName?: boolean
}

const props = defineProps<Props>()

const isMatch = (link: RouteLocationRaw) => {
  const r = router.resolve(link)
  if (props.matchOnPathName) return route.name === r.name
  return route.fullPath === r.fullPath
}
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CNavigationList',
})
</script>
